<template>
    <div class="form-group">
        <form @submit.prevent="search">
                <div class="row">
                    <div class="col-md-4">
                        <b-form-checkbox v-if="withSeeDeactivated" v-model="links.seeDeactivated" style="" class="mt-2" switch>Ver Desactivados
                        </b-form-checkbox>
                    </div>
                    <div class="col-md-8">
                        <div class="input-group">
                            <input class="form-control" v-model="links.search" :placeholder="placeholder" type="text" />
                            <button type="button" @click="search" class="btn btn-outline-secondary" title="buscar..." >
                                <i class="fa fa-search"></i>
                            </button>
                            <button type="button" class="btn btn-outline-secondary" title="Quitar filtro" @click="reset">
                                <i class="fa fa-sync-alt"></i>
                            </button>
                        </div>
                    </div>
                </div>
        </form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                filter: { }
            }
        },
        props: ['links', 'placeholder', 'withSeeDeactivated'],
        methods: {
            index() {
                this.$emit('index');
            },
            reset() {
                this.filter = {};
                this.$router.push({
                    path: this.$route.path
                })
                
            },
            showModal() {
                this.$emit('showModal', true);
            },
            search() {
                this.filter.seeDeactivated = this.links.seeDeactivated;

                if (this.links.search)
                    this.filter.search = this.links.search;

                this.$router.push({
                    path: this.$route.path,
                    query: this.filter
                })
            }
        }
    }

</script>